import React from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import DeleteUserConfirmationModal from './DeleteUserConfirmationModal';

const UserDataTable = ({
  data, // NOSONAR
  filteredData, // NOSONAR
  loading, // NOSONAR
  onRowClick, // NOSONAR
  showDeleteModal, // NOSONAR
  userToDelete, // NOSONAR
  deleteLoading, // NOSONAR
  handleDeleteClick, // NOSONAR
  handleDeleteConfirm, // NOSONAR
  handleDeleteCancel, // NOSONAR
  columns, // NOSONAR
  defaultSortFieldId = "firstName", // NOSONAR
  title = "", // NOSONAR
  pagination = true, // NOSONAR
  highlightOnHover = true, // NOSONAR
  persistTableHead = true, // NOSONAR
}) => {
  const { getUserDetail } = useSelector((state) => state.auths);
  const isAdmin = getUserDetail?.role === 1;
  const getColumns = () => {
    const baseColumns = [
      {
        id: "firstName",
        name: "First Name",
        selector: (row) => row.firstName,
        sortable: true,
        sortAsc: true,
      },
      {
        id: "lastName",
        name: "Last Name",
        selector: (row) => row.lastName,
        sortable: true,
      },
      {
        id: "email",
        name: "Email",
        selector: (row) => (row.email ? row.email : "-"),
        sortable: true,
      },
      {
        id: "phoneNumber",
        name: "Phone Number",
        selector: (row) => (row.phoneNumber ? row.phoneNumber : "-"),
        sortable: true,
      },
    ];

    // Add service type column for attorney/fiduciary users
    if (columns?.includes('serviceType')) { // NOSONAR
      baseColumns.push({
        id: "professionalServiceType",
        name: "Service Type",
        selector: (row) => {
          if (row.professionalServiceType) {
            return row.professionalServiceType.charAt(0).toUpperCase() + row.professionalServiceType.slice(1);
          }
          if (row.role === 6) {
            return 'Fiduciary';
          }
          return 'Attorney';
        },
        sortable: true,
      });
    }

    // Add session columns
    baseColumns.push(
      {
        id: "createdAt",
        name: "Last Session",
        selector: (row) =>
          moment(row.createdAt).format("MM/DD/yyyy @ HH:mm PT"),
        sortable: true,
      },
      {
        id: "updatedAt",
        name: "Last Updated",
        selector: (row) =>
          moment(row.updatedAt).format("MM/DD/yyyy @ HH:mm PT"),
        sortable: true,
      }
    );

    // Add actions column if delete functionality is enabled AND user is admin
    if (handleDeleteClick && isAdmin) {
      baseColumns.push({
        id: "actions",
        name: "Actions",
        cell: (row) => ( // NOSONAR
          <button
            className={`btn btn-danger btn-sm ${row._id === getUserDetail?._id && 'opacity-50 not-allowed'}`}
            onClick={(e) => {
              e.stopPropagation();
              if(row._id === getUserDetail?._id) return;
              handleDeleteClick(row);
            }}
            title="Delete User"
          >
            Delete
          </button>
        ),
        ignoreRowClick: true,
      });
    }

    return baseColumns;
  };

  return (
    <>
      <DataTable
        title={title}
        columns={getColumns()}
        data={filteredData || data}
        pagination={pagination}
        onRowClicked={onRowClick}
        highlightOnHover={highlightOnHover}
        defaultSortFieldId={defaultSortFieldId}
        persistTableHead={persistTableHead}
      />

      {handleDeleteClick && isAdmin && (
        <DeleteUserConfirmationModal
          show={showDeleteModal}
          onHide={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
          userName={userToDelete ? `${userToDelete.firstName} ${userToDelete.lastName}` : ""}          userEmail={userToDelete ? userToDelete.email : ""}          loading={deleteLoading}
        />
      )}
    </>
  );
};

export default UserDataTable;
